import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DialogWrapper({
    open,
    onClose,
    title,
    icon,
    children,
    actions,
    maxWidth = "sm",
    fullWidth = true,
    disablePadding = false,
    fixedHeight,
    PaperProps,
}) {
    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            PaperProps={{
                ...PaperProps,
                sx: {
                    borderRadius: 3,
                    display: "flex",
                    flexDirection: "column",
                    ...(fixedHeight
                        ? {
                            height: fixedHeight,
                            maxHeight: fixedHeight,
                        }
                        : {}),
                    ...PaperProps?.sx,
                },
            }}
        >
            {(title || icon || onClose) && (
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        pr: 1,
                        flexShrink: 0,
                    }}
                >
                    {icon && (
                        <Box
                            component="img"
                            src={typeof icon === "string" ? icon : undefined}
                            alt=""
                            sx={{ width: 22, height: 22 }}
                        />
                    )}

                    {title && (
                        <Typography
                            sx={{
                                fontSize: "1.1rem",
                                fontWeight: 700,
                                flex: 1,
                            }}
                        >
                            {title}
                        </Typography>
                    )}

                    {onClose && (
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </DialogTitle>
            )}

            <DialogContent
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    overflowX: "hidden",
                    p: disablePadding ? 0 : 2,

                    /* hide scrollbar */
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                }}
            >
                {children}
            </DialogContent>

            {actions && (
                <DialogActions
                    sx={{
                        justifyContent: "center",
                        gap: 1,
                        px: 2,
                        pb: 2,
                        flexShrink: 0,
                    }}
                >
                    {actions}
                </DialogActions>
            )}
        </Dialog>
    );
}